/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { SaveEmailForMarketingRequest, SaveEmailForMarketingResponse } from './api.schemas';

import { api } from '../util/http';

export const createMarketingSubscriptions = (
  saveEmailForMarketingRequest: SaveEmailForMarketingRequest,
  signal?: AbortSignal,
) => {
  return api<SaveEmailForMarketingResponse>({
    url: `/api/marketing/subscriptions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: saveEmailForMarketingRequest,
    signal,
  });
};

export const getCreateMarketingSubscriptionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarketingSubscriptions>>,
    TError,
    { data: SaveEmailForMarketingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMarketingSubscriptions>>,
  TError,
  { data: SaveEmailForMarketingRequest },
  TContext
> => {
  const mutationKey = ['createMarketingSubscriptions'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMarketingSubscriptions>>,
    { data: SaveEmailForMarketingRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createMarketingSubscriptions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMarketingSubscriptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMarketingSubscriptions>>
>;
export type CreateMarketingSubscriptionsMutationBody = SaveEmailForMarketingRequest;
export type CreateMarketingSubscriptionsMutationError = unknown;

export const useCreateMarketingSubscriptions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMarketingSubscriptions>>,
      TError,
      { data: SaveEmailForMarketingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMarketingSubscriptions>>,
  TError,
  { data: SaveEmailForMarketingRequest },
  TContext
> => {
  const mutationOptions = getCreateMarketingSubscriptionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
